$(document).ready(function ($) {
  "use strict"; 
  function megaMenu() {
    if($('.default_dropdown').length > 0 ) {
    if ($("#header .page-full-width").length) {
      var parentRow = $("#header .page-full-width > .row");
      var parentLeft = parseInt(parentRow.css("marginLeft").replace("px", ""));
    } else {
      var parentRow = $("#header .page-width .row");
      var parentLeft = parseInt(parentRow.offset().left);
    }
    var parentWidth = parentRow.width();

    $("#header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > .dt-sc-nav-link").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);
        thisItem.find(".sub-menu-block").css("width", parentWidth);
       }
    });

    $("sticky-header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > .dt-sc-nav-link").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);        
        thisItem.find(".sub-menu-block").css("width", parentWidth);      
      }
    });
    window.setTimeout(function () {
      $(window).trigger("resize");
    }, 800);

    }
  }
  var megaMenuResize = false;
  $(window).bind("resize", function () {
    if (!megaMenuResize) {
      megaMenu();
      megaMenuResize = true;
    }
  });
  megaMenu();
});

(function () {
  function syncMenuTrigger(trigger) {
    var item = trigger.closest(".top-level-link");
    if (!item) return;
    trigger.setAttribute("aria-expanded", item.matches(":hover, :focus-within") ? "true" : "false");
  }

  document.querySelectorAll("[data-menu-toggle]").forEach(function (trigger) {
    var item = trigger.closest(".top-level-link");
    if (!item) return;
    ["mouseenter", "mouseleave", "focusin", "focusout"].forEach(function (eventName) {
      item.addEventListener(eventName, function () {
        window.requestAnimationFrame(function () {
          syncMenuTrigger(trigger);
        });
      });
    });
    syncMenuTrigger(trigger);
  });
})();

$(function () {
  if ($(window).width() >= 1200) {
    $(".deskTabs a").click(function () {
      let id = $(this).attr("href");
      $(".deskTabs li").removeClass("active");
      $(this).parent().addClass("active");
      $(this).parent().parent().parent().parent().addClass("active");
      $(".tabs-content li.dt-sc-menu-tabs").hide();
      $(this).parent().parent().parent().parent().find(id).show();

      return false;
    });
  }
  if ($(window).width() <= 1199) {
    $(".mobileTabs .tabs  li").each(function () {
      $(this).click(function () {
        $(this).next("div").slideToggle(0);
      });
    });
  }
});
$(document).ready(function () {
  $("#category-menu-button").click(function () {
    $(this).toggleClass("open");
    $(".category-wrapper").toggleClass("open");
    $(".category-wrapper").slideToggle(0);
  });
});

/* Desktop dropdowns are positioned below the header while their triggers sit
   inside it. Measure that real gap and give the parent li a transparent bridge
   so its :hover state survives the trip into the panel. */
(function () {
  var bridgeItems = ".header__inline-menu .dt-nav > li.menu-item-has-children";
  var desktopPointer = window.matchMedia("(min-width: 990px) and (hover: hover) and (pointer: fine)");
  var resizeFrame;

  function translateY(element) {
    var transform = window.getComputedStyle(element).transform;
    var values;

    if (!transform || transform === "none") return 0;

    values = transform.match(/^matrix\((.+)\)$/);
    if (values) return parseFloat(values[1].split(",")[5]) || 0;

    values = transform.match(/^matrix3d\((.+)\)$/);
    return values ? parseFloat(values[1].split(",")[13]) || 0 : 0;
  }

  function updateHoverBridges() {
    document.querySelectorAll(bridgeItems).forEach(function (item) {
      var panel = item.querySelector(":scope > .megamenu_megamenu > .sub-menu-block");
      var menu = item.closest(".header__inline-menu");

      item.style.removeProperty("--desktop-dropdown-hover-gap");

      if (!desktopPointer.matches || !panel || !menu || window.getComputedStyle(menu).display === "none") return;

      /* Hidden panels are translated upward by the theme. Remove that current
         translate amount to obtain their visible (open) top edge. */
      var triggerBottom = item.getBoundingClientRect().bottom;
      var panelRect = panel.getBoundingClientRect();
      var openPanelTop = panelRect.top - translateY(panel);
      var gap = Math.max(0, Math.ceil(openPanelTop - triggerBottom));

      item.style.setProperty("--desktop-dropdown-hover-gap", gap + "px");
    });
  }

  function scheduleBridgeUpdate() {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(updateHoverBridges);
  }

  document.addEventListener("DOMContentLoaded", updateHoverBridges);
  window.addEventListener("load", updateHoverBridges);
  window.addEventListener("resize", scheduleBridgeUpdate);
  desktopPointer.addEventListener("change", updateHoverBridges);

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateHoverBridges);
})();
